import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue";
var _hoisted_1 = ["src"];
var _hoisted_2 = ["src"];
import { ref, toRefs } from '../../../adapter-vue';
import { isUniFrameWork } from '../../../utils/env';
var defaultAvatarUrl = "https://web.sdk.qcloud.com/component/TUIKit/assets/avatar_21.png";
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    url: {
      "default": "https://web.sdk.qcloud.com/component/TUIKit/assets/avatar_21.png"
    },
    size: {
      "default": "36px"
    },
    borderRadius: {
      "default": "5px"
    },
    useSkeletonAnimation: {
      type: Boolean,
      "default": false
    }
  },
  emits: ["onLoad", "onError"],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var emits = __emit;
    var props = __props;
    var _toRefs = toRefs(props),
      avatarSize = _toRefs.size,
      avatarImageUrl = _toRefs.url,
      avatarBorderRadius = _toRefs.borderRadius,
      useAvatarSkeletonAnimation = _toRefs.useSkeletonAnimation;
    var isImgLoaded = ref(false);
    var loadErrorInUniapp = ref(false);
    function avatarLoadSuccess(e) {
      isImgLoaded.value = true;
      emits('onLoad', e);
    }
    function avatarLoadFailed(e) {
      if (isUniFrameWork) {
        loadErrorInUniapp.value = true;
      } else {
        e.currentTarget.src = defaultAvatarUrl;
      }
      emits('onError', e);
    }
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", {
        "class": "avatar-container",
        style: _normalizeStyle({
          width: _unref(avatarSize),
          height: _unref(avatarSize),
          borderRadius: _unref(avatarBorderRadius)
        })
      }, [_unref(isUniFrameWork) ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [!_unref(loadErrorInUniapp) ? (_openBlock(), _createElementBlock("image", {
        key: 0,
        "class": "avatar-image",
        src: _unref(avatarImageUrl) || defaultAvatarUrl,
        onLoad: avatarLoadSuccess,
        onError: avatarLoadFailed
      }, null, 40, _hoisted_1)) : (_openBlock(), _createElementBlock("image", {
        key: 1,
        "class": "avatar-image",
        src: defaultAvatarUrl,
        onLoad: avatarLoadSuccess,
        onError: avatarLoadFailed
      }, null, 32))], 64)) : (_openBlock(), _createElementBlock("img", {
        key: 1,
        "class": "avatar-image",
        src: _unref(avatarImageUrl) || defaultAvatarUrl,
        onLoad: avatarLoadSuccess,
        onError: avatarLoadFailed
      }, null, 40, _hoisted_2)), _unref(useAvatarSkeletonAnimation) ? (_openBlock(), _createElementBlock("div", {
        key: 2,
        "class": _normalizeClass({
          placeholder: true,
          hidden: _unref(isImgLoaded),
          'skeleton-animation': _unref(useAvatarSkeletonAnimation)
        })
      }, null, 2)) : _createCommentVNode("", true)], 4);
    };
  }
});